import { Box } from '@/components/Box'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { GridCellProps } from '@progress/kendo-react-grid'
import {
  ClientContestResultsDto,
  ClientContestResultsKey,
} from 'api/Trading-Accounts/Types/MarketingCampaignResultsDto'
import classNames from 'classnames'
import { Info } from 'lucide-react'

import { GridColumn } from './CampaignDetailsResultsPage'

import styles from './CampaignDetailsForm.module.scss'

const campaignClientContestResultsColumn: GridColumn[] = [
  {
    title: 'Ranking',
    show: true,
    className: 'table-columns__content',
    filterable: true,
    filter: 'text',
    field: ClientContestResultsKey.ranking,
    cell: (props: GridCellProps): JSX.Element => {
      const item = props.dataItem as ClientContestResultsDto
      if (item.disqualified) {
        return (
          <td className={styles.disqualified}>
            <Box display='flex' alignItems='center' gap={2}>
              Disqualified
              <Tooltip key='top'>
                <TooltipTrigger>
                  <Info size={14} />
                </TooltipTrigger>
                <TooltipContent side='top'>
                  {`Reason: ${item?.disqualificationRule?.businessRule?.name}`}
                </TooltipContent>
              </Tooltip>
            </Box>
          </td>
        )
      } else {
        return (
          <td className={classNames({ [styles.disqualified]: item.disqualified })}>
            {item.ranking}
          </td>
        )
      }
    },
  },
  {
    title: 'Client Name',
    show: true,
    className: 'table-columns__content',
    filterable: true,
    filter: 'text',
    field: ClientContestResultsKey.clientName,

    cell: (props: GridCellProps): JSX.Element => {
      const item = props.dataItem as ClientContestResultsDto
      return (
        <td className={classNames({ [styles.disqualified]: item.disqualified })}>
          {item.clientName}
        </td>
      )
    },
  },
  {
    title: 'Account',
    show: true,
    className: 'table-columns__content',
    filterable: true,
    filter: 'text',
    field: ClientContestResultsKey.login,
    cell: (props: GridCellProps): JSX.Element => {
      const item = props.dataItem as ClientContestResultsDto
      return (
        <td className={classNames({ [styles.disqualified]: item.disqualified })}>{item.login}</td>
      )
    },
  },
  {
    title: 'Contest Points',
    show: true,
    className: 'table-columns__number',
    filterable: true,
    filter: 'text',
    field: ClientContestResultsKey.contestPoints,
    cell: (props: GridCellProps): JSX.Element => {
      const item = props.dataItem as ClientContestResultsDto
      return (
        <td className={classNames({ [styles.disqualified]: item.disqualified })}>
          {item.contestPoints}
        </td>
      )
    },
  },
]

export default campaignClientContestResultsColumn
